import { ReactNode, useRef } from 'react'
import { MenuListProps } from 'react-select'

import { SelectOption } from '@/lib/core/components/Select'
import { StyledActionOption } from '@/lib/core/components/Select/components/Option.styles'
import { TooltipContainerProvider } from '@/lib/core/components/Tooltip'

type SettingsProps = {
  actionOption?: ReactNode
  actionCallback?: () => void
}

type MenuListComponentProps = MenuListProps<SelectOption> & SettingsProps

const MenuListComponent = ({
  actionOption,
  actionCallback,
  children,
  innerProps,
  innerRef,
  getStyles,
  ...props
}: MenuListComponentProps) => {
  const menuListStyles = getStyles('menuList', {
    children,
    innerProps,
    innerRef,
    getStyles,
    ...props,
  })
  const containerRef = useRef<HTMLDivElement>(null)

  return (
    <div
      // @ts-expect-error There is an issue with passing styles on because of the getStyles function
      css={{
        ...menuListStyles,
        maxHeight: (menuListStyles.maxHeight as number) - 1,
      }}
      ref={(node) => {
        containerRef.current = node
        if (typeof innerRef === 'function') {
          innerRef(node)
        } else if (innerRef) {
          innerRef.current = node
        }
      }}
      {...innerProps}
    >
      <TooltipContainerProvider container={containerRef.current}>
        {actionOption && (
          <StyledActionOption onClick={actionCallback}>{actionOption}</StyledActionOption>
        )}
        {children}
      </TooltipContainerProvider>
    </div>
  )
}

export const MenuList = ({ actionOption, actionCallback }: SettingsProps) => {
  const WrappedMenuList = (props: MenuListProps<SelectOption>) => (
    <MenuListComponent {...props} actionOption={actionOption} actionCallback={actionCallback} />
  )
  WrappedMenuList.displayName = 'MenuList'
  return WrappedMenuList
}
